import { observer } from "mobx-react";
import * as React from "react";

import { SelectionMode } from "@fluentui/react";
import { Section } from "../ui/atoms/section";
import { ListVehicles, ListVehiclesLayout } from "../ui/molecules/list-vehicles";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageMaintenance extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.maintenanceReport]}
                breadcrumb={store.i18n.t("page.maintenance.title")}
                classic
            >
                <Section fill>
                    <ListVehicles
                        selectionMode={SelectionMode.none}
                        columnLayout={ListVehiclesLayout.Maintenance}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
